import React from 'react';

import Footer from './Footer';

const Terms = (props) => {

    return (
        <div>
            <div className="cent-content-white">
                <div className="cent-page cent-page-formal">
                    <p>These Terms and Conditions of Use (the "Terms of Use") applies to all products, applications and
                        services ("applications") offered by Premier IT but
                        excludes any products applications or services that have separate Terms of Use which do not
                        incorporate this Terms of Use.</p>
                    <p>BY USING THE APPLICATION, YOU AGREE TO THESE TERMS OF USE; IF YOU DO NOT AGREE, DO NOT USE THE
                        APPLICATION.</p>

                    <h3>1. Acceptable use</h3>
                    <p>You must use Premier IT applications only for its intended purpose and only by means of the
                        online interactive user
                        interface made available by us.</p>

                    <ul className="cent-ul-text">
                        <li>Do not use the application to transmit or upload or otherwise publish any material that:
                            <ul className="cent-ul-text">
                                <li>is defamatory, abusive, obscene, of a harassing nature or in any other way
                                    offensive
                                </li>
                                <li>infringes anyone else's copyright or other intellectual property rights</li>
                                <li>infringes any right of privacy, confidentiality or legal privilege</li>
                            </ul>
                        </li>

                        <li>You must not use, transfer, copy, reverse engineer, create a functional specification of or
                            reproduce any
                            part of Premier IT applications (or its source code)
                        </li>

                        <li>You must not use any mechanism, device, software, script or routine to affect the proper
                            functioning of the
                            application, or take any action that places an unreasonable burden or excessive load on our
                            servers(s), or
                            negligently or knowingly infect Premier IT applications with any computer programming
                            routine (e.g. any virus, worm,
                            time bomb, cancelbot or trojan horse) that may damage, interfere with, delay, intercept or
                            expropriate any
                            system, data or personal information.
                        </li>
                    </ul>

                    <h3>2. Security</h3>
                    <p>We are committed to ensuring that your information is secure. In order to prevent unauthorised
                        access or
                        disclosure, we have put in place suitable physical, electronic and managerial procedures to
                        safeguard and
                        secure the information we collect online.</p>

                    <p>The security of any documents/data downloaded from Premier IT applications, becomes the
                        responsibility of the user.
                        We cannot be held responsible for the security of data copied to and held outside of our
                        systems. Such
                        information should only be accessed from a secure computer and/or held in a safe place.</p>

                    <h4>Your obligations</h4>
                    <ul className="cent-ul-text">
                        <li>Do not attempt to access Premier IT applications unless we have issued you with your own
                            username and
                            password.
                        </li>
                        <li>Do not access Premier IT applications using someone else's username or password.</li>
                        <li>Do not disclose or reveal to any other person, your username or password</li>
                        <li>Take reasonable action to keep your user name and password secret</li>
                        <li>Take reasonable action to prevent anyone else from accessing Premier IT applications by
                            means of your user
                            name and password
                        </li>
                        <li>Change your password immediately if you think someone else knows your password, or whenever
                            we
                            request that you do so
                        </li>
                        <li>Notify us promptly of any unauthorised use of your username or password or any other breach
                            of
                            security
                        </li>
                    </ul>

                    <p>We reserve the right to issue you with a new username and/or password if we believe someone else
                        knows
                        your password or is accessing Premier IT applications using your username or password.</p>
                    <h3>3. Changes to our Terms of Use</h3>
                    <p>Premier IT reserves the right, at its sole discretion, to change, modify, add or remove portions
                        of these
                        Terms of Use, at any time. It is your responsibility to check these Terms of Use periodically
                        for
                        changes. Your continued use of the application following the posting of changes will mean that
                        you accept
                        and agree to the changes. As long as you comply with these Terms of Use, Premier IT grants you a
                        limited privilege to enter and use the application.</p>
                    <p><a href="https://support.premierit.com" target="_blank">support.premierit.com</a></p>
                    <p><em>10th December 2018</em></p>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default Terms;